import api from '../axiosConfig';

// Get recent stock issues
export const getRecentStockIssues = async (params = {}) => {
  try {
    console.log('Calling getRecentStockIssues with params:', params);
    const response = await api.get('/api/dashboard/recent-issues', { params });
    console.log('getRecentStockIssues response:', response.data);
    return response.data;
  } catch (error) {
    console.error('getRecentStockIssues error:', error);
    throw error.response?.data?.message || error.message;
  }
};

// Get recent stock returns
export const getRecentStockReturns = async (params = {}) => {
  try {
    console.log('Calling getRecentStockReturns with params:', params);
    const response = await api.get('/api/dashboard/recent-returns', { params });
    console.log('getRecentStockReturns response:', response.data);
    return response.data;
  } catch (error) {
    console.error('getRecentStockReturns error:', error);
    throw error.response?.data?.message || error.message;
  }
};

// Get department-wise pending data
export const getDepartmentWisePendingData = async (params = {}) => {
  try {
    console.log('Calling getDepartmentWisePendingData with params:', params);
    const response = await api.get('/api/reports/department-wise-pending', { params });
    console.log('getDepartmentWisePendingData response:', response.data);
    return response.data;
  } catch (error) {
    console.error('getDepartmentWisePendingData error:', error);
    throw error.response?.data?.message || error.message;
  }
};

// Get department-wise production data
export const getDepartmentWiseProductionData = async (params = {}) => {
  try {
    console.log('Calling getDepartmentWiseProductionData with params:', params);
    const response = await api.get('/api/reports/department-wise-production', { params });
    console.log('getDepartmentWiseProductionData response:', response.data);
    return response.data;
  } catch (error) {
    console.error('getDepartmentWiseProductionData error:', error);
    throw error.response?.data?.message || error.message;
  }
};

// Get batch summary
export const getBatchSummary = async (params = {}) => {
  try {
    console.log('Calling getBatchSummary with params:', params);
    const response = await api.get('/api/dashboard/batch-summary', { params });
    console.log('getBatchSummary response:', response.data);
    return response.data;
  } catch (error) {
    console.error('getBatchSummary error:', error);
    throw error.response?.data?.message || error.message;
  }
};

// Get pending summary
export const getPendingSummary = async (params = {}) => {
  try {
    console.log('Calling getPendingSummary with params:', params);
    const response = await api.get('/api/dashboard/pending-summary', { params });
    console.log('getPendingSummary response:', response.data);
    return response.data;
  } catch (error) {
    console.error('getPendingSummary error:', error);
    throw error.response?.data?.message || error.message;
  }
};

// Get all dashboard data in one call
export const getDashboardData = async (params = {}) => {
  try {
    console.log('Calling getDashboardData with params:', params);
    const [recentIssues, recentReturns, pendingData, productionData] = await Promise.all([
      getRecentStockIssues(params),
      getRecentStockReturns(params),
      getDepartmentWisePendingData(params),
      getDepartmentWiseProductionData(params)
    ]);
    
    const result = {
      recentIssues,
      recentReturns,
      departmentWisePending: pendingData,
      departmentWiseProduction: productionData
    };
    
    console.log('getDashboardData final result:', result);
    return result;
  } catch (error) {
    console.error('getDashboardData error:', error);
    throw error.response?.data?.message || error.message;
  }
}; 